import { hasValue } from 'Lib/Any';

/**
 * Maps non-printable character codes to an appropriate replacement
 */
const nonPrintableCharReplacements: { [code: number]: number } = {
  /**
   * Characters 00 - 31 map to control pictures 0x2400 - 0x2431
   */
  ...Object.fromEntries(Array.from({ length: 32 }, (_, i) => [i, 0x2400 + i])),
  /**
   * SPACE
   */
  32: 0x2423,
  /**
   * DEL
   */
  127: 0x2421,
};

/**
 * Replaces non printable characters with unicode control pictures for display
 */
export const replaceNonPrintableChars = (value: string | undefined) =>
  value
    ?.split('')
    .map((c) => {
      const replacementCode = nonPrintableCharReplacements[c?.charCodeAt(0)];
      return hasValue(replacementCode) ? String.fromCodePoint(replacementCode) : c;
    })
    .join('');
